import { Table, Text, Image } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { BloodPressureItem } from 'models/bloodpressure';
import { formatDate } from 'utils/dates';
import classes from 'global.module.css';
import { useGetBloodPressureMeasurementComment } from 'hooks/api/bloodpressure/useGetBloodPressureMeasurementComment';

interface BloodPressureDetailsProps {
  item?: BloodPressureItem;
}

export const BloodPressureDetails = ({ item }: BloodPressureDetailsProps) => {
  const { t } = useTranslation();
  const { data: comment } = useGetBloodPressureMeasurementComment({ documentId: item?.id });

  const rows = [
    {
      label: t('blood_pressure_sys_dia_label'),
      value: item?.bloodPressure,
    },
    {
      label: t('severity_label'),
      value: item?.classification.label ? t(`severity_${item?.classification.label}`) : null,
    },
    {
      label: t('pulse_pressure_label'),
      value: `${item?.pulsePressure}`,
    },
    {
      label: t('symptoms_label'),
      value: item?.symptoms.map((symptom) => t(`symptom_${symptom}`)).join(', '),
    },
    {
      label: t('comment_label'),
      value: comment,
    },
    {
      label: t('attachment_label'),
      value: <Image src={item?.attachment} />,
    },
  ];

  return (
    <>
      <Text mb={10} size={'sm'}>
        {t('measured_on_label')} {formatDate({ timestamp: item?.date as number, formatWithTime: true })}
      </Text>
      <Table className={classes.chartTooltip}>
        <tbody>
          {rows.map((v) => (
            <tr key={v.label}>
              <td style={{ minWidth: 100, verticalAlign: 'top' }}>{v.label}</td>
              <td>{v.value}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};
